<script setup lang="ts">
import { computed } from 'vue'

import FormFilterCheckbox from '@storefront-satch/components/atoms/input/FormFilterCheckbox.vue'
import FormFilterRadio from '@storefront-satch/components/atoms/input/FormFilterRadio.vue'
import FormSlider from '@storefront-satch/components/atoms/input/FormSlider.vue'
import FilterListItem from '@storefront-satch/components/molecules/filter/FilterListItem.vue'
import FilterForm from '@storefront-satch/components/molecules/filter/FilterListItemForm.vue'
import type { Filter } from '@storefront-satch/components/molecules/filter/types'
import { t } from '@storefront-satch/lib/translations'

const props = defineProps<{
  selectedFilter: Record<string, string[]>
  filter: Filter[]
  disallowedSortOptions?: string[]
}>()

const filter = computed(() => {
  return {
    price: props.filter.filter((f) => f.type === 'PRICE_RANGE')[0],
    rest: props.filter.filter((f) => f.type !== 'PRICE_RANGE'),
  }
})

const defaultSortKeys = [
  {
    name: 'BEST_SELLING',
    id: 'BEST_SELLING',
    label: String(t('filter.bestseller')),
  },
  { name: 'PRICE', id: 'PRICE', label: String(t('price.DEFAULT')) },
  { name: 'TITLE', id: 'TITLE', label: 'Name' },
]

const sortKeys = computed(() => {
  if (typeof props.disallowedSortOptions === 'undefined') {
    return []
  }

  return defaultSortKeys.filter(({ name }) =>
    props.disallowedSortOptions?.every((option) => option !== name)
  )
})

const sort = {
  id: 'sort',
  label: String(t('filter.sort')),
  name: 'sort',
  values: sortKeys.value,
  default: sortKeys.value,
}
</script>

<template>
  <div class="mb-2.5 mt-4 flex w-full flex-wrap items-center gap-2">
    <FilterForm
      v-for="(item, index) in filter.rest"
      :key="index"
      :filter="props.filter"
      :selected-filter="props.selectedFilter"
    >
      <FilterListItem :filter="item">
        <template #form-input>
          <FormFilterCheckbox :filter="item" />
        </template>
      </FilterListItem>
    </FilterForm>

    <FilterForm
      :filter="props.filter"
      :selected-filter="props.selectedFilter"
    >
      <FilterListItem
        v-if="filter.price"
        :filter="filter.price"
      >
        <template #form-input>
          <FormSlider
            :min="Number(filter.price.default[0]?.input?.price?.min)"
            :max="Number(filter.price.default[0]?.input?.price?.max)"
            :name="filter.price.id"
            :label="filter.price.label"
            format-description="money"
          />
        </template>
      </FilterListItem>
    </FilterForm>

    <FilterForm
      :filter="props.filter"
      :selected-filter="props.selectedFilter"
    >
      <FilterListItem :filter="sort">
        <template #form-input>
          <FormFilterRadio :filter="sort" />
        </template>
      </FilterListItem>
    </FilterForm>
  </div>
</template>
